export const APP_FILE_TEMPLATES_LIST = "/templates";
export const APP_FILE_MESSAGING_TEMPLATES = "/templates/manage-template";
